import React from 'react'
import { Routes, Route } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'

import { Home } from 'Containers/home'
import { Providers } from 'Utils/Providers'
import { Router } from 'Utils/router'

export const App = () => {
  return (
    <Providers>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path='/tour/:appMode/:instId/:locId?' element={<Home />} />
        </Routes>
      </Router>
    </Providers>
  )
}
